import { render, staticRenderFns } from "./BodyguardServiceGeneralInfo.vue?vue&type=template&id=4198e198&scoped=true"
import script from "./BodyguardServiceGeneralInfo.vue?vue&type=script&lang=js"
export * from "./BodyguardServiceGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./BodyguardServiceGeneralInfo.vue?vue&type=style&index=0&id=4198e198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4198e198",
  null
  
)

export default component.exports